<div class="account">
    <div
      class="account_icon"
      [ngStyle]="{
        'background-image': 'url(' +  channel?.url + ')',
        'width': channel?.width
      }"
    ></div>
    <div class="account_name">
        {{account}}
    </div>

</div>

